import { CATEGORY_DISPLAY_MAP, CATEGORY_ICON_MAP, FALLBACK_ICON } from './category-map';

interface CategoryIconProps {
  category: string;
  size?: number;
  className?: string;
  label?: string;
  'aria-hidden'?: boolean;
}

export function CategoryIcon({
  category,
  size = 24,
  className,
  label,
  'aria-hidden': ariaHidden,
}: CategoryIconProps) {
  const key = category.trim().toLowerCase();
  const Icon = CATEGORY_ICON_MAP[key] ?? FALLBACK_ICON;
  const resolvedLabel = label ?? CATEGORY_DISPLAY_MAP[key] ?? category;

  if (ariaHidden) {
    return <Icon size={size} className={className} aria-hidden="true" />;
  }

  return (
    <Icon
      size={size}
      className={className}
      role="img"
      aria-label={resolvedLabel}
    />
  );
}
